import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformTitle',
  standalone: true,
})
export class TransformTitlePipe implements PipeTransform {
  transform(value: string): string {
    return value
      ? value
          .split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ')
      : value;
  }
}
